<div class="pmt" *ngIf="this.paymentTitleStatus && targetData?.payment_status">
  <div class="pmt-title">
    {{'MODALS.TEXT.'+ this.paymentTitleStatus |translate}}
  </div>
  <div class="pmt-summary contract-grid-first-border" >
      <img class="pmt-summary-icon"  [src]="'assets/images/contract/payment-status/' + contractPaymentStatusIconMap.get(targetData?.payment_status)" >
      <div class="pmt-summary-amount">
        <div class="pmt-summary-amount-title" >{{'MODALS.TEXT.TRANSACTION_AMOUNT'|translate}}</div>
        <div class="pmt-summary-amount-data" >{{paymentTotal  | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</div>
      </div>
  </div>
  <div class="pmt-details contract-grid-first-border" *ngIf="paymentDetails">
    <div class="pmt-details-item" *ngFor="let item of paymentDetails"> 
      <span class="pmt-details-item-key">{{'FINANCE.PAYMENT.'+item.key|translate}}</span>
      <span [class]="'pmt-details-item-value ' + (item.key==='status'?  item.value : '' )" >{{item.value}}</span>
    </div>
  </div>
  <div class="pmt-button-block">
    <button (click)="cancelAction()" class="button-icon size-xxl secondary-button">
       <mat-icon svgIcon="close-fill"></mat-icon>
      {{ 'MODALS.BUTTONS.CLOSE'|translate }}
    </button>
  </div>
</div>